import api from '../../service/modules/integrity'
export default {
    namespaced: true,
    state: {
      mobile: '15623556684',
      userInfo: '',
      cityCode: '',
      cityName: ''
    },
    mutations: {
        // 获取基础信息
      getUserInfo: (state, data) => {
        state.userInfo = data;
      }
    },
    actions: {
      getUser: (context, data) => {
          api.getUser(data).then(res => {
              context.commit('getUserInfo', res.data)
          });
       }
  }
  }
